import React from 'react'

export const PopUpSkeleton: React.FC = () => {
  return (
    <div className="w-full rounded-md lg:w-[428px] bg-bg-base-transparent-95 lg:max-h-[460px] h-full mt-6">
      <div className="flex flex-col gap-6">
        <div className="flex flex-col gap-4">
          <div>
            <div className="animate-pulse h-4 bg-gray-200 rounded w-16 mb-2"></div>
            <div className="animate-pulse h-10 bg-bg-base rounded w-full border border-border-input"></div>
          </div>
          <div>
            <div className="animate-pulse h-4 bg-gray-200 rounded w-16 mb-2"></div>
            <div className="animate-pulse h-[120px] bg-bg-base rounded w-full border border-border-input"></div>
          </div>
          <div className="flex justify-end mt-2">
            <div className="animate-pulse h-[38px] w-[72px] bg-blue-20 rounded"></div>
          </div>
        </div>
      </div>
    </div>
  )
}
